import { applyMiddleware, createStore as reduxCreateStore } from 'redux'
import thunk from 'redux-thunk'

import storeReducer from '../reducers'

const middlewares = [thunk]

const initReduxDevTools = () => {
  if (
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ) {
    return window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()
  }
}

const createStoreWithMiddleware = applyMiddleware(...middlewares)(
  reduxCreateStore
)

export const createStore = (initialState, ...rest) => {
  return createStoreWithMiddleware(
    storeReducer,
    initialState,
    initReduxDevTools(),
    ...rest
  )
}
